export * from './deviceDetect'
